module.exports = __webpack_public_path__ + "img/12.99239e81.png";